import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
export var SessionLogoutListenerMock = /*#__PURE__*/function () {
  function SessionLogoutListenerMock() {
    _classCallCheck(this, SessionLogoutListenerMock);
  }

  _createClass(SessionLogoutListenerMock, [{
    key: "init",
    // @ts-ignore
    // tslint:disable-next-line
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ticketNumber) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }() // tslint:disable-next-line

  }, {
    key: "close",
    value: function close() {}
  }]);

  return SessionLogoutListenerMock;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zZXNzaW9uTG9nb3V0TGlzdGVuZXIvU2Vzc2lvbkxvZ291dExpc3RlbmVyTW9jay50cyJdLCJuYW1lcyI6WyJTZXNzaW9uTG9nb3V0TGlzdGVuZXJNb2NrIiwidGlja2V0TnVtYmVyIl0sIm1hcHBpbmdzIjoiOzs7O0FBRUEsV0FBYUEseUJBQWI7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUNFO0FBQ0E7QUFGRjtBQUFBLDRGQUdvQkMsWUFIcEI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSxRQUtFOztBQUxGO0FBQUE7QUFBQSw0QkFNaUIsQ0FBRTtBQU5uQjs7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2Vzc2lvbkxvZ291dExpc3RlbmVySW50ZXJmYWNlIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgY2xhc3MgU2Vzc2lvbkxvZ291dExpc3RlbmVyTW9jayBpbXBsZW1lbnRzIFNlc3Npb25Mb2dvdXRMaXN0ZW5lckludGVyZmFjZSB7XG4gIC8vIEB0cy1pZ25vcmVcbiAgLy8gdHNsaW50OmRpc2FibGUtbmV4dC1saW5lXG4gIHB1YmxpYyBhc3luYyBpbml0KHRpY2tldE51bWJlcj86IHN0cmluZykge31cblxuICAvLyB0c2xpbnQ6ZGlzYWJsZS1uZXh0LWxpbmVcbiAgcHVibGljIGNsb3NlKCkge31cbn1cbiJdfQ==